/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartItems_portfolioItems$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartLayout_portfolioItems$ref: FragmentReference;
export type CartLayout_portfolioItems = {|
  +totalResults: ?number,
  +pageInfo: {|
    +hasNextPage: boolean
  |},
  +edges: ?$ReadOnlyArray<?{|
    +node: ?{|
      +item: ?{|
        +categoryPath: ?string
      |}
    |}
  |}>,
  +$fragmentRefs: CartItems_portfolioItems$ref,
  +$refType: CartLayout_portfolioItems$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartLayout_portfolioItems",
  "type": "PortfolioItemsConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartItems_portfolioItems",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pageInfo",
      "storageKey": null,
      "args": null,
      "concreteType": "PageInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasNextPage",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PortfolioItemsEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "PortfolioItemV2",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "item",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "categoryPath",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1d476664870487dc38b0f5cbe12a6b2c';
module.exports = node;
